import { Currency, CurrencyAmount, Token } from '@kodiak-finance/sdk-core'
import { ButtonPrimary } from 'components/Button'
import { LightCard } from 'components/Card'
import Column from 'components/Column'
import CurrencyLogo from 'components/CurrencyLogo'
import { AutoRow, RowBetween } from 'components/Row'
import ConfirmationTransactionStep, {
  ConfirmationTransactionStepProps,
} from 'components/StepLine/common/ConfirmationTransactionStep'
import { useCurrency } from 'hooks/Tokens'
import { usePoolUnderlyingBalances } from 'hooks/usePoolPositionDetails'
import { Text } from 'rebass'
import { IslandApiResponse } from 'state/data/slice'

type WithdrawFromIslandStepProps = {
  shares?: CurrencyAmount<Token> | null
  pool?: IslandApiResponse | null
  next: () => void
  onWithdraw: () => void
  overrideCurrencyA?: Currency
  overrideCurrencyB?: Currency
} & Omit<ConfirmationTransactionStepProps, 'children' | 'onConfirm'>

export default function WithdrawFromIslandStep({
  shares,
  pool,
  next,
  onWithdraw,
  overrideCurrencyA,
  overrideCurrencyB,
  ...rest
}: WithdrawFromIslandStepProps) {
  const token0 = useCurrency(pool?.token0.id)
  const token1 = useCurrency(pool?.token1.id)
  const baseCurrency0 = overrideCurrencyA ?? token0
  const baseCurrency1 = overrideCurrencyB ?? token1

  const displayCurrency0 = baseCurrency0 ?? undefined
  const displayCurrency1 = baseCurrency1 ?? undefined

  const underlyingBalances = usePoolUnderlyingBalances(pool ?? null, shares, displayCurrency0, displayCurrency1)

  return (
    <ConfirmationTransactionStep {...rest} onConfirm={next}>
      <Column width="100%" gap="8px">
        <LightCard>
          <RowBetween>
            <AutoRow gap="4px">
              <CurrencyLogo currency={displayCurrency0} size="21px" />
              <Text fontSize="14px">{displayCurrency0?.symbol}</Text>
            </AutoRow>
            <Text>{underlyingBalances.amount0?.toSignificant(6)}</Text>
          </RowBetween>
        </LightCard>
        <LightCard>
          <RowBetween>
            <AutoRow gap="4px">
              <CurrencyLogo currency={displayCurrency1} size="21px" />
              <Text fontSize="14px">{displayCurrency1?.symbol}</Text>
            </AutoRow>
            <Text>{underlyingBalances.amount1?.toSignificant(6)}</Text>
          </RowBetween>
        </LightCard>

        <ButtonPrimary onClick={onWithdraw}>
          Withdraw {shares?.toSignificant(6)} {shares?.currency?.symbol}
        </ButtonPrimary>
      </Column>
    </ConfirmationTransactionStep>
  )
}
